import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

type DataRow = {
  [key: string]: any;
};

interface ResponsiveTableProps {
  data: DataRow[];
  displayKeys?: string[];
}

const ResponsiveTable: React.FC<ResponsiveTableProps> = ({ data, displayKeys }) => {
  const theme = useAtomValue(themeAtom);
  const keysToDisplay = displayKeys || (data.length > 0 ? Object.keys(data[0]) : []);

  if (data.length === 0) {
    return <p>No data available</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className={twMerge("min-w-full", theme.home.tailwind.textDefault)}>
        <thead>
          <tr className={twMerge("border", theme.uwhcAssistant.border)}>
            <th className="h-14 px-4 py-2 text-xs font-semibold">#</th> {/* Add # header */}
            {keysToDisplay.map((key, index) => (
              <th key={index} className="h-14 px-4 py-2 text-xs font-semibold">
                {key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className={twMerge("border", theme.uwhcAssistant.border)}>
              <td className="h-14 px-4 py-2 text-center text-xs">{rowIndex + 1}</td> {/* Add index count */}
              {keysToDisplay.map((displayKey, columnIndex) => (
                <td key={columnIndex} className="h-14 px-4 py-2 text-center text-xs">
                  {row[displayKey]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResponsiveTable;
